import { render, staticRenderFns } from "./password-reset.html?vue&type=template&id=a6a23322&scoped=true&"
import script from "./password-reset.js?vue&type=script&lang=js&"
export * from "./password-reset.js?vue&type=script&lang=js&"
import style0 from "./password-reset.scss?vue&type=style&index=0&id=a6a23322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a23322",
  null
  
)

export default component.exports